<template>
  <div>
    <header-bar :name='"拍摄技巧"'></header-bar>
    <div class="skilllist">

      <router-link to="m_vlogskill" class="item">
        <div >
          <img src="../img/skilllist_1.png" alt="">
          <div class="title">
            短视频拍摄技巧
          </div>
        </div>
      </router-link>
      <router-link to="m_makevlogskill" class="item">
        <div >
          <img src="../img/skilllist_2.png" alt="">
          <div class="title">
            短视频制作技巧
          </div>
        </div>
      </router-link>
      <router-link to="m_plogskill" class="item">
        <div >
          <img src="../img/skilllist_3.png" alt="">
          <div class="title">
            图片拍摄技巧
          </div>
        </div>
      </router-link>
      <router-link to="m_makeplogskill" class="item">
        <div >
          <img src="../img/skilllist_4.png" alt="">
          <div class="title">
            图片制作技巧
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import headerBar from './common/headerBar'

export default {
  name: 'skilllist',
  components: {
    headerBar
  },
  data: function () {
      return {
          
      }
  },
  methods: {
    routerTo(path) {
      this.$router.push(path)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.skilllist {
  width: calc(100% - 0.96rem);
  min-height: 100%;
  padding-bottom: 6rem;
  margin: 0 0.48rem 0.48rem;
  text-align: center;
  font-size: 20px;
  text-align: left;
  .item {
    display: inline-block;
    width: calc(50% - 0.15rem);
    margin-top: 0.53rem;
    &:nth-child(even) {
      margin-left: 0.3rem;
    }
    img {
      width: 100%;
    }
    &:last-child {
      margin-right: 0;
    }
    &:hover {
      .title {
        color: #000;
      }
    }
    .title {
      text-align: center;
      font-size: 0.55rem;
      margin-top: 0.33rem;
      color: #282828;
    }
  }
}
</style>
